// Payment source sent on every payment and tokenization request made by
// Embedded Component V1, so payments are traceable to it (PLA-3946).
export const EMBEDDED_COMPONENT_SOURCE = 'payin-embedcomponent-v1';
